module.exports = __webpack_public_path__ + "img/img-3.67d86a2d.png";